import { render, staticRenderFns } from "./CrawlData.vue?vue&type=template&id=8664568c&scoped=true"
import script from "./CrawlData.vue?vue&type=script&lang=js"
export * from "./CrawlData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8664568c",
  null
  
)

export default component.exports